<template>
    <div class="main">
        <div class="elder_manage_title">
            <p class="title">社区管理</p>
        </div>
        <div class="publicMain">
            <!-- 左边卡片 -->
            <el-card class="card-l">
                <el-tree
                    :expand-on-click-node="false"
                    class="cardtree"
                    v-if="lookdata"
                    :data="data"
                    node-key="id"
                    default-expand-all
                >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span>
                            <i class="party-icon"></i
                            ><span
                                class="tree-node-span"
                                @click="lookDataFun(data)"
                                >{{ data.communityName }}</span
                            ><i
                                class="el-icon-s-add"
                                @click="addDataFun(data)"
                            ></i
                            ><i
                                v-if="
                                    !data.children || data.children.length === 0
                                "
                                class="el-icon-delete"
                                @click="deletDataFun(data.id)"
                            ></i>
                        </span>
                    </span>
                </el-tree>
                <!-- <el-tree v-if="lookdata == true" :data="data" :props="defaultProps" accordion @node-click="handleNodeClick"></el-tree> -->
            </el-card>
            <!-- 右边卡片 -->
            <div class="card-rb" ref="cardRb">
                <div class="card-4">
                    <el-card :body-style="{ padding: '16px' }">
                        <el-form
                            :model="ruleForm"
                            size="small"
                            ref="ruleForm"
                            class="demo-ruleForm"
                        >
                            <div class="ruleForm_box">
                                <div class="ruleForm_item">
                                    <el-form-item prop="parentId">
                                        <div class="rulelable">
                                            所属上级组织：
                                        </div>
                                        <el-input
                                            disabled
                                            v-model="ruleForm.parentName"
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item prop="communityName">
                                        <div class="rulelable">组织名称：</div>
                                        <el-input
                                            class="ruleinput"
                                            v-model="ruleForm.communityName"
                                        ></el-input>
                                    </el-form-item>

                                    <el-form-item prop="phone">
                                        <div class="rulelable">联系方式：</div>
                                        <el-input
                                            class="ruleinput"
                                            v-model="ruleForm.phone"
                                            :maxlength="11"
                                        ></el-input>
                                    </el-form-item>
                                </div>
                                <div class="ruleForm_item">
                                    <el-form-item>
                                        <div class="ZUZHIimg">
                                            <div class="threestyleimg">
                                                <div class="threestyleimgtu">
                                                    <img
                                                        :src="
                                                            ruleForm.photo ||
                                                            eddimgurl
                                                        "
                                                        alt
                                                        style="
                                                            width: 100%;
                                                            height: 200px;
                                                        "
                                                    />
                                                </div>
                                                <div
                                                    class="threestyleimgbtnzzxz"
                                                >
                                                    <input
                                                        type="file"
                                                        @change="upimg"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="dialogBody">
                                <el-form-item label="居住地址：">
                                    <el-button
                                        type="danger"
                                        icon="el-icon-location-outline"
                                        @click="location"
                                        >定位到标准地址</el-button
                                    >
                                </el-form-item>
                            </div>
                            <el-form-item label="" v-show="mapshow">
                                <el-row>
                                    <el-col :span="4">
                                        <el-form-item>
                                            <el-select
                                                v-model="ruleForm.shengId"
                                                placeholder="请选择省"
                                                @change="handleProvince"
                                                :disabled="
                                                    normalInfo.orgLevel == 1 ||
                                                    normalInfo.orgLevel == 2 ||
                                                    normalInfo.orgLevel == 3 ||
                                                    normalInfo.orgLevel == 4 ||
                                                    normalInfo.orgLevel == 5
                                                "
                                                ref="selectShengChange"
                                                style="width: 100%"
                                            >
                                                <el-option
                                                    v-for="(
                                                        item, index
                                                    ) in provinceList"
                                                    :key="index"
                                                    :label="item.name"
                                                    :value="item.adcode"
                                                >
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="4" :offset="1">
                                        <el-select
                                            v-model="ruleForm.shiId"
                                            :disabled="
                                                normalInfo.orgLevel == 2 ||
                                                normalInfo.orgLevel == 3 ||
                                                normalInfo.orgLevel == 4 ||
                                                normalInfo.orgLevel == 5
                                            "
                                            @change="handleCity"
                                            ref="selectShiChange"
                                            style="width: 100%"
                                        >
                                            <el-option
                                                v-for="(
                                                    item, index
                                                ) in cityList"
                                                :key="index"
                                                :label="item.name"
                                                :value="item.adcode"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col :span="4" :offset="1">
                                        <el-select
                                            v-model="ruleForm.quId"
                                            :disabled="
                                                normalInfo.orgLevel == 2 ||
                                                normalInfo.orgLevel == 3 ||
                                                normalInfo.orgLevel == 4 ||
                                                normalInfo.orgLevel == 5
                                            "
                                            placeholder="请选择区"
                                            @change="handleArea"
                                            ref="selectQuChange"
                                            style="width: 100%"
                                        >
                                            <el-option
                                                v-for="(
                                                    item, index
                                                ) in areaList"
                                                :key="index"
                                                :label="item.name"
                                                :value="item.adcode"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col :span="4" :offset="1">
                                        <el-select
                                            :disabled="
                                                normalInfo.orgLevel == 3 ||
                                                normalInfo.orgLevel == 4 ||
                                                normalInfo.orgLevel == 5
                                            "
                                            v-model="ruleForm.jiedaoId"
                                            placeholder="请选择街道"
                                            @change="streetChange"
                                            ref="selectJiedaoChange"
                                        >
                                            <el-option
                                                v-for="(
                                                    item, index
                                                ) in streetList"
                                                :key="index"
                                                :label="item.addName"
                                                :value="item.addCode"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col :span="4" :offset="1">
                                        <el-select
                                            :disabled="
                                                normalInfo.orgLevel == 4 ||
                                                normalInfo.orgLevel == 5
                                            "
                                            v-model="ruleForm.shequId"
                                            placeholder="请选择社区"
                                            ref="selectShequChange"
                                            @change="handleCommunityChange"
                                        >
                                            <el-option
                                                v-for="item in communityList"
                                                :key="item.id"
                                                :label="item.address"
                                                :value="item.id"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                </el-row>
                                <input
                                    v-model.trim="ruleForm.address"
                                    id="tipinput"
                                    class="el-input__inner"
                                    @focus="getMap('tipinput')"
                                    placeholder="请输入关键字"
                                    autocomplete="off"
                                />
                                <!-- <el-input
                                    v-model.trim="ruleForm.address"
                                    style="
                                        margin-top: 12px;
                                        margin-bottom: 12px;
                                    "
                                    placeholder="请在地图的边界内点击选择详细信息"
                                    @blur="joinAddress('address')"
                                ></el-input> -->
                                <div class="map_container">
                                    <div
                                        class="map_right"
                                        id="container"
                                        style="width: 100%; height: 300px"
                                    ></div>
                                </div>
                            </el-form-item>
                            <div>
                                <el-form-item prop="orgIntroduce">
                                    <div class="rulelable">组织简介：</div>
                                    <div>
                                        <quillEditor
                                            v-model="ruleForm.introduce"
                                            style="
                                                width: 100%;
                                                height: 250px;
                                                margin-bottom: 35px;
                                            "
                                        >
                                        </quillEditor>
                                    </div>
                                </el-form-item>
                            </div>
                            <template>
                                <div style="margin-top: 60px">
                                    <div
                                        style="
                                            display: flex;
                                            padding: 10px 0;
                                            justify-content: space-between;
                                        "
                                        v-for="(item, index) in member"
                                        :key="index"
                                    >
                                        <div style="width: 20%">
                                            <div class="member-title">
                                                成员职位:
                                            </div>
                                            <el-select
                                                size="mini"
                                                v-model="item.post"
                                                placeholder="请选择"
                                                style="width: 90%"
                                            >
                                                <el-option
                                                    label="委员会书记"
                                                    value="1"
                                                ></el-option>
                                                <el-option
                                                    label="委员会副书记"
                                                    value="2"
                                                ></el-option>
                                                <el-option
                                                    label="委员会委员"
                                                    value="3"
                                                ></el-option>
                                            </el-select>
                                        </div>
                                        <div style="width: 20%">
                                            <div class="member-title">
                                                成员姓名:
                                            </div>
                                            <el-input
                                                style="width: 90%"
                                                size="mini"
                                                v-model="item.memberName"
                                                placeholder="请输入"
                                            ></el-input>
                                        </div>
                                        <div style="width: 10%">
                                            <div class="member-title">
                                                排序:
                                            </div>
                                            <el-input
                                                style="width: 90%"
                                                size="mini"
                                                v-model="item.sort"
                                                placeholder="请输入"
                                                >{{ item.post }}
                                            </el-input>
                                        </div>
                                        <div style="width: 20%">
                                            <div class="member-title">
                                                成员照片:
                                            </div>
                                            <div
                                                style="
                                                    width: 90%;
                                                    display: flex;
                                                    align-items: center;
                                                "
                                            >
                                                <el-upload
                                                    :show-file-list="false"
                                                    class="upload-demo"
                                                    :action="baseUrl"
                                                    :on-success="
                                                        (response) =>
                                                            uploadSuccess(
                                                                response,
                                                                index
                                                            )
                                                    "
                                                >
                                                    <el-button
                                                        size="small"
                                                        type="primary"
                                                        >点击上传</el-button
                                                    >
                                                </el-upload>
                                                <a
                                                    v-if="item.photo"
                                                    :href="item.photo"
                                                    target="_blank"
                                                    style="color: #00aaee"
                                                    >预览图片</a
                                                >
                                                <div v-else>无</div>
                                            </div>
                                        </div>
                                        <div
                                            style="
                                                width: 20%;
                                                display: flex;
                                                align-items: center;
                                                justify-content: flex-end;
                                            "
                                        >
                                            <el-button
                                                size="small"
                                                type="danger"
                                                @click="deleteMember(index)"
                                            >
                                                删除该成员
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <el-form-item>
                                <el-button
                                    style="margin-left: 20px"
                                    type="primary"
                                    size="mini"
                                    @click="addMember"
                                    >添加委员会成员
                                </el-button>
                            </el-form-item>
                            <div class="ruleForm_bottom">
                                <el-form-item>
                                    <el-button
                                        type="primary"
                                        @click="submitForm"
                                        >保存</el-button
                                    >
                                    <el-button @click="cleardata"
                                        >取消</el-button
                                    >
                                </el-form-item>
                            </div>
                        </el-form>
                    </el-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import baseURL from "@/api/baseURL"
import { post } from "@/api/requrestHttp"
import { uploadPartyPhoto } from "@/api/requrestHttp"
import upimg from "@/components/uploadImg/index.vue"
import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"
import "quill/dist/quill.bubble.css"
import { quillEditor } from "vue-quill-editor"

export default {
    components: {
        quillEditor,
        upimg,
    },
    data() {
        return {
            provinceList: [], //省列表
            cityList: [], //市列表
            areaList: [], //区列表
            streetList: [], //街道列表
            communityList: [], //社区列表
            myMap: null,
            marker: null, //地图标记点
            polygons: [],
            isMap: true,
            member: [],
            committeeIds: [],
            gridIds: [],
            orgIntroduce: "",
            data5: [
                {
                    id: 1,
                    communityName: "秋浦街道",
                    icon: "el-icon-success",
                },
            ],
            orgid: "",
            findById: false,
            eddimgurl: require("../../assets/image112/zuzhiimg.png"),
            //地图显示
            mapshow: false,
            lookdata: false,
            //验证
            ruleForm: {
                parentId: "0",
                shengId: "", //省
                shiId: "", //市
                quId: "", //区
                jiedaoId: "", //街道
                shequId: "", //社区
                address: "", //地址
            },
            //防止重复提交 禁用按钮
            isDisabled: false,
            //  树形控件
            data: [],
            // 树形控件的配置
            defaultProps: {
                children: "children",
                label: "label",
            },
            baseUrl: "",
            normalInfo: {},
        }
    },
    methods: {
        // 文件上传成功
        uploadSuccess(response, index) {
            console.log(response)
            if (response.code === 200) {
                // this.$set(item, "photo", response.content)
                this.member[index].photo = response.content
                console.log(index, "第几个")
            }
        },
        // 删除成员
        deleteMember(index) {
            this.$confirm("此操作将删除该成员, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(async () => {
                this.member.splice(index, 1)
            })
        },
        addMember() {
            this.member.push(this.getMember())
        },
        getMember() {
            return {
                photo: "",
                memberName: "",
                post: "",
                sort: "",
            }
        },

        deletDataFun(id) {
            post("/ypt/admin/community/info/deleteById", { id: id }).then(
                (res) => {
                    console.log(res)
                    if (res.code === 200) {
                        this.cleardata()
                        this.findTreelist()
                    }
                }
            )
        },
        async addDataFun(data) {
            console.log(data)
            this.cleardata()
            this.mapshow = false
            const self = this
            if (!data.shengId) return
            let city = await self.getDistricts(String(data.shengId))
            self.cityList = city.districtList
            console.log(self.cityList, "城市")
            if (!data.shiId) return
            let area = await self.getDistricts(String(data.shiId))
            self.areaList = area.districtList
            console.log(self.areaList, "区")
            if (!data.quId) return
            let street = await self.getStreetList(String(data.quId))
            self.streetList = street
            console.log(self.streetList, "街道")
            if (!data.jiedaoId) return
            let communityList = await self.getCommityList(String(data.jiedaoId))
            self.communityList = communityList
            console.log(self.communityList, "社区")
            this.ruleForm = {
                parentId: data.id,
                parentName: data.communityName,
                communityType: 1,
                shengId: String(data.shengId),
                shiId: String(data.shiId),
                quId: String(data.quId),
                jiedaoId: String(data.jiedaoId),
                shequId: Number(data.shequId),
                longitude: data.longitude,
                latitude: data.latitude,
            }

            this.$nextTick(() => {
                // setTimeout(() => {
                this.loadmap("container")
                if (
                    self.ruleForm.longitude &&
                    self.ruleForm.latitude &&
                    this.mapshow == true
                ) {
                    self.potintMap()
                }
                // }, 500)
            })
        },
        lookDataFun(data) {
            let data1 = data
            let self = this
            this.cleardata()
            let params = {
                id: data1.id,
            }
            params = Object.assign({}, params)
            post("/ypt/admin/community/info/get", params).then(async (res) => {
                self.ruleForm = res.content
                self.ruleForm.parentName = data.parentName
                const list = self.ruleForm.leaders
                if (list && Array.isArray(list)) {
                    self.member = list.slice()
                    let jsonTemp = { ...res.content }
                    self.ruleForm.longitude = jsonTemp.longitude
                    self.ruleForm.latitude = jsonTemp.latitude
                    self.ruleForm.address = jsonTemp.address //社区地址
                    self.ruleForm.shengId = jsonTemp.shengId
                        ? String(jsonTemp.shengId)
                        : "" //省
                    self.ruleForm.shiId = jsonTemp.shiId
                        ? String(jsonTemp.shiId)
                        : "" //市
                    self.ruleForm.quId = jsonTemp.quId
                        ? String(jsonTemp.quId)
                        : "" //区
                    self.ruleForm.jiedaoId = jsonTemp.jiedaoId
                        ? String(jsonTemp.jiedaoId)
                        : "" //街道
                    self.ruleForm.shequId = jsonTemp.shequId
                        ? Number(jsonTemp.shequId)
                        : "" //社区
                    if (!self.ruleForm.shengId) return
                    let city = await self.getDistrict(self.ruleForm.shengId)
                    self.cityList = city.districtList
                    if (!self.ruleForm.shiId) return
                    let area = await self.getDistrict(self.ruleForm.shiId)
                    self.areaList = area.districtList
                    if (!self.ruleForm.quId) return
                    let street = await self.getStreetList(self.ruleForm.quId)
                    self.streetList = street
                    if (!self.ruleForm.jiedaoId) return
                    let communityList = await self.getCommityList(
                        self.ruleForm.jiedaoId
                    )
                    self.communityList = communityList
                    // self.streetChange(self.ruleForm.jiedaoId, true)
                    if (
                        self.ruleForm.longitude &&
                        self.ruleForm.latitude &&
                        self.mapshow == true
                    ) {
                        self.$nextTick(() => {
                            // setTimeout(() => {
                            self.loadmap("container")
                            if (
                                self.ruleForm.longitude &&
                                self.ruleForm.latitude &&
                                self.mapshow == true
                            ) {
                                console.log("111")
                                self.potintMap()
                            }
                            // }, 500)
                        })
                    }
                }
            })
        },
        cleardata() {
            this.ruleForm = {}
            this.member = []
        },
        submitForm() {
            if (!this.ruleForm.communityName) {
                this.$message({ message: "请输入组织全称" })
                return
            }
            if (!this.ruleForm.phone) {
                this.$message({ message: "请输入联系方式" })
                return
            }
            if (!this.ruleForm.shengId) {
                this.$message.error("省级地址为必填项，请选择")
                return
            }
            if (!this.ruleForm.shiId) {
                this.$message.error("市级地址为必填项，请选择")
                return
            }
            if (!this.ruleForm.quId) {
                this.$message.error("区县级地址为必填项，请选择")
                return
            }
            if (!this.ruleForm.jiedaoId) {
                this.$message.error("街道地址为必填项，请选择")
                return
            }
            if (!this.ruleForm.parentId) {
                this.ruleForm.parentId = "0"
            }
            console.log(this.ruleForm)
            this.ruleForm.leaders = this.member
            post("/ypt/admin/community/info/save", {
                ...this.ruleForm,
            }).then((res) => {
                this.member = []
                console.log(res)
                if (res.code === 200) {
                    this.$message({ message: res.message, type: "success" })
                    this.lookdata = false
                    this.cleardata()
                    this.findTreelist()
                }
            })
            if (this.map) {
                this.map.clearMap()
                this.map.destroy()
            }
            this.mapshow = false
        },
        //获取社区组织树形数据
        async findTreelist() {
            this.$http
                .request({
                    url: "/ypt/admin/community/info/CommunityTree",
                    method: "POST",
                    data: {},
                })
                .then((res) => {
                    this.data = res.content
                    if (res.content) {
                        this.lookdata = true
                    }
                })
        },
        // Editor文字修改
        editorUpdate(val) {
            this.orgIntroduce = val
        },
        async upimg(e) {
            if (e.target.files[0] == null) {
                return false
            } else {
                let fd = new FormData()
                fd.append("file", e.target.files[0])
                uploadPartyPhoto(fd)
                    .then((res) => {
                        this.$emit("input", res.content)
                        this.$set(this.ruleForm, "photo", res.content)
                        e.target.value = null
                    })
                    .catch((error) => {
                        this.$message.error("上传失败")
                    })

                console.log(this.ruleForm.photo)
            }
        },
        // 地图
        getMap(input) {
            const self = this
            const autoOptions = {
                city: this.ruleForm.quId,
                citylimit: true,
                input: input,
            }
            // alert(input)
            const auto = new AMap.Autocomplete(autoOptions)
            //构造地点查询类
            AMap.event.addListener(auto, "select", (e) => {
                self.ruleForm.address = e.poi.name
                self.ruleForm.longitude = e.poi.location.lng
                self.ruleForm.latitude = e.poi.location.lat

                self.loadmap("container")
                setTimeout(() => {
                    self.potintMap()
                }, 500)
            })
        },
        joinAddress(address = "") {
            let self = this
            self.$nextTick(() => {
                console.log(this.$refs.selectShengChange)
                let shengName = this.$refs.selectShengChange.selectedLabel
                let shiName = this.$refs.selectShiChange.selectedLabel
                let quName = this.$refs.selectQuChange.selectedLabel
                let jiedaoName = this.$refs.selectJiedaoChange.selectedLabel
                let shequName = this.$refs.selectShequChange.selectedLabel
                if (!address) {
                    self.ruleForm.address =
                        shengName + shiName + quName + jiedaoName + shequName
                }
                try {
                    self.myMap.remove(self.marker)
                } catch (err) {
                    console.log(err)
                }
                let geocoder = new AMap.Geocoder({ city: "" })
                self.marker = new AMap.Marker()
                geocoder.getLocation(
                    this.ruleForm.address,
                    function (status, result) {
                        if (status === "complete" && result.geocodes.length) {
                            let lnglat = result.geocodes[0].location
                            self.ruleForm.longitude = lnglat.lng
                            self.ruleForm.latitude = lnglat.lat
                            self.marker.setPosition(lnglat)
                            self.myMap.add(self.marker)
                            self.myMap.setFitView(self.marker)
                        } else {
                            log.error("根据地址查询位置失败")
                        }
                    }
                )
            })
        },
        //获取地址
        getDistrict(name = "中国", params = null) {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 1, //返回下一级行政区
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                let geocoder = new AMap.Geocoder({
                    city: "", //城市设为北京，默认：“全国”
                    radius: 1000, //范围，默认：500
                })
                try {
                    self.myMap.remove(self.marker)
                } catch (err) {
                    console.log(err)
                }
                self.marker = new AMap.Marker()
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0])
                        if (this.isMap) {
                            this.isMap = false
                            return
                        }
                        let bounds = result.districtList[0].boundaries
                        self.polygon = null
                        if (bounds) {
                            try {
                                self.myMap.remove(self.polygons)
                            } catch (error) {
                                console.log("移除地图编辑出错了")
                            }
                            self.polygons = []
                            for (let i = 0, l = bounds.length; i < l; i++) {
                                self.polygon = new AMap.Polygon({
                                    map: self.myMap,
                                    strokeWeight: 1,
                                    strokeColor: "#0091ea",
                                    fillColor: "#80d8ff",
                                    fillOpacity: 0.4,
                                    path: bounds[i],
                                })
                                self.polygons.push(self.polygon)
                                if (!params) {
                                    self.polygon.on("click", function (e) {
                                        let lnglat = e.lnglat
                                        self.myMap.add(self.marker)
                                        self.marker.setPosition(lnglat)
                                        geocoder.getAddress(
                                            lnglat,
                                            function (status, result) {
                                                if (
                                                    status === "complete" &&
                                                    result.regeocode
                                                ) {
                                                    var address =
                                                        result.regeocode
                                                            .formattedAddress
                                                    self.ruleForm.address =
                                                        address
                                                    self.ruleForm.longitude =
                                                        lnglat.lng
                                                    self.ruleForm.latitude =
                                                        lnglat.lat
                                                } else {
                                                    console.error(
                                                        "根据经纬度查询地址失败"
                                                    )
                                                }
                                            }
                                        )
                                    })
                                    self.myMap.add(self.polygons)
                                    self.myMap.setFitView() //地图自适应
                                } else {
                                    if (params.longitude && params.latitude) {
                                        self.myMap.add(self.marker)
                                        self.marker.setPosition([
                                            params.longitude,
                                            params.latitude,
                                        ])
                                        self.myMap.setFitView(self.marker)
                                        self.myMap.setZoom(11)
                                    }
                                }
                            }
                        }
                    }
                })
            }).catch((err) => {
                console.log(err)
            })
        },

        // 地图显示
        location() {
            this.mapshow = !this.mapshow
            if (this.mapshow == true) {
                this.$nextTick(() => {
                    this.loadmap("container")
                    setTimeout(() => {
                        this.potintMap()
                    }, 500)
                })
            }
        },
        // 地图初始化
        loadmap(index) {
            let self = this
            return new Promise((resolve, reject) => {
                self.myMap = new AMap.Map(index, {
                    resizeEnable: true,
                    zoom: 18,
                })
                resolve()
            })
        },
        //获取省级
        async getProvince() {
            this.provinceLis = []
            this.cityList = []
            this.areaList = []
            this.streetList = []
            let province = await this.getDistrict()
            this.provinceList = province.districtList
        },
        //  省级地址选择发生改变
        async handleProvince(val) {
            this.cityList = []
            this.areaList = []
            this.streetList = []
            this.communityList = []
            this.ruleForm.shiId = ""
            this.ruleForm.quId = ""
            this.ruleForm.jiedaoId = ""
            this.ruleForm.shequId = ""
            this.ruleForm.address = ""
            let city = await this.getDistrict(val)
            this.cityList = city.districtList
            this.joinAddress()
        },
        //市级地址发生改变
        async handleCity(val) {
            this.areaList = []
            this.streetList = []
            this.communityList = []
            this.ruleForm.quId = ""
            this.ruleForm.jiedaoId = ""
            this.ruleForm.shequId = ""
            this.ruleForm.address = ""
            let area = await this.getDistrict(val)
            this.areaList = area.districtList
            this.joinAddress()
        },
        //县区级地址发生改变
        async handleArea(val) {
            this.streetList = []
            this.communityList = []
            this.ruleForm.jiedaoId = ""
            this.ruleForm.shequId = ""
            this.ruleForm.address = ""
            let street = await this.getStreetList(val)
            this.streetList = street
            this.joinAddress()
        },
        //街道地址发生变化
        async streetChange(val) {
            this.ruleForm.shequId = ""
            let communityList = await this.getCommityList(val)
            this.communityList = communityList
            this.joinAddress()
        },
        //街道地址列表
        getStreetList(val) {
            let self = this
            return new Promise((resolve, reject) => {
                self.$http
                    .request({
                        url: "/ypt/admin/addressYpe/info/findList",
                        method: "POST",
                        data: {
                            parentId: val,
                            pageNo: 1,
                            pageSize: -1,
                        },
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            if (!res.content) {
                                resolve([])
                                return
                            }
                            this.streetList = res.content.list
                            resolve(res.content.list)
                        } else {
                            resolve([])
                        }
                    })
            }).catch((err) => {
                console.log(err)
            })
        },
        // 社区地址列表
        getCommityList(val) {
            let self = this
            return new Promise((resolve, reject) => {
                self.$http
                    .request({
                        url: "/ypt/admin/standardAddress/info/StandardAddressTree",
                        method: "POST",
                        data: {
                            jiedaoId: val,
                        },
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            if (!res.content) {
                                resolve([])
                                return
                            }
                            resolve(res.content)
                        } else {
                            resolve([])
                        }
                    })
            }).catch((err) => {
                console.log(err)
            })
        },
        //社区地址发生变化
        handleCommunityChange() {
            this.joinAddress()
        },
        // 获取机构
        getOrg() {
            this.$http
                .request({
                    url: "/rbac/admin/org/info/findOrgById",
                    method: "POST",
                    data: { id: this.$store.state.info.orgId },
                })
                .then((res) => {
                    if (res.code == 200) {
                        // this.getProvince()
                        this.normalInfo = res.content
                        this.changeFirst()
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        //获取地址
        getDistricts(name = "中国", params = null) {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 1, //返回下一级行政区
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                let geocoder = new AMap.Geocoder({
                    city: "", //城市设为北京，默认：“全国”
                    radius: 1000, //范围，默认：500
                })
                try {
                    self.myMap.remove(self.marker)
                } catch (err) {
                    console.log(err)
                }

                self.marker = new AMap.Marker()
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0])
                        if (this.isMap) {
                            this.isMap = false
                            return
                        }
                        let bounds = result.districtList[0].boundaries
                        self.polygon = null
                    }
                })
            }).catch((err) => {
                console.log(err)
            })
        },
        async changeFirst() {
            console.log(
                this.normalInfo,
                "机构信息 normalInfo.orgLevel",
                this.provinceList
            )
            let province = await this.getDistricts()
            this.provinceList = province.districtList
            if (this.normalInfo.provinceId == 0) {
                this.normalInfo.provinceId = ""
            } else {
                this.normalInfo.provinceId = String(this.normalInfo.provinceId)
                let cityList = await this.getDistricts(
                    this.normalInfo.provinceId
                )
                this.cityList = cityList.districtList
                console.log("城市", this.cityList)
            }
            if (this.normalInfo.cityId) {
                this.normalInfo.cityId = String(this.normalInfo.cityId)
                let areaList = await this.getDistricts(this.normalInfo.cityId)
                this.areaList = areaList.districtList
            } else {
                this.normalInfo.cityId = ""
            }

            if (this.normalInfo.areaId) {
                this.normalInfo.areaId = String(this.normalInfo.areaId)
                let streetList = await this.getStreetList(
                    this.normalInfo.areaId
                )
                this.streetList = streetList
            } else {
                this.normalInfo.areaId = ""
            }
            if (this.normalInfo.streetId) {
                this.normalInfo.streetId = String(this.normalInfo.streetId)
                let communityList = await this.getCommityList(
                    this.normalInfo.streetId
                )
                this.communityList = communityList
            } else {
                this.normalInfo.streetId = ""
            }
            if (
                this.normalInfo.orgLevel == 1 ||
                this.normalInfo.orgLevel == 0
            ) {
                this.provinceList.forEach((item) => {
                    if (item.adcode == this.normalInfo.provinceId) {
                        this.ruleForm.latitude = item.center.lat
                        this.ruleForm.longitude = item.center.lng
                    }
                })
            } else if (this.normalInfo.orgLevel == 2) {
                this.cityList.forEach((item) => {
                    if (item.adcode == this.normalInfo.cityId) {
                        this.ruleForm.latitude = item.center.lat
                        this.ruleForm.longitude = item.center.lng
                    }
                })
            } else if (this.normalInfo.orgLevel == 3) {
                this.areaList.forEach((item) => {
                    if (item.adcode == this.normalInfo.areaId) {
                        this.ruleForm.latitude = item.center.lat
                        this.ruleForm.longitude = item.center.lng
                    }
                })
            } else if (
                this.normalInfo.orgLevel == 4 ||
                this.normalInfo.orgLevel == 5
            ) {
                this.streetList.forEach((item, index) => {
                    if (item.addCode == this.normalInfo.streetId) {
                        this.ruleForm.latitude = item.latitude
                        this.ruleForm.longitude = item.longitude
                    }
                })
            }

            if (this.normalInfo.communityId) {
                this.normalInfo.communityId = Number(
                    this.normalInfo.communityId
                )
            } else {
                this.normalInfo.communityId = ""
            }

            this.ruleForm.shengId = this.normalInfo.provinceId
            this.ruleForm.shiId = this.normalInfo.cityId
            this.ruleForm.quId = this.normalInfo.areaId
            this.ruleForm.jiedaoId = this.normalInfo.streetId
            this.ruleForm.shequId = this.normalInfo.communityId
            this.ruleForm.address = this.normalInfo.address
                ? this.normalInfo.address
                : ""
            // this.potintMap()
            this.$forceUpdate()
            // console.log(this.normalInfo, "机构信息",this.)
        },

        // 打点
        potintMap() {
            const self = this
            try {
                self.myMap.remove(self.marker)
            } catch (err) {
                console.log(err)
            }
            self.marker = new AMap.Marker({
                icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
                position: [
                    Number(this.ruleForm.longitude),
                    Number(this.ruleForm.latitude),
                ],
            })
            self.myMap.add(self.marker)
            self.myMap.setFitView()
        },
    },
    mounted() {
        this.findTreelist()
    },
    created() {
        this.getProvince()
        this.getOrg()
        this.baseUrl =
            baseURL + "/ypt/controller/uploadController/info/uploadPhoto"
    },
}
</script>

<style lang="less" scoped>
.main {
    background: #fff;
}
.elder_manage_title {
    position: relative;
    width: 100%;
    margin-bottom: 15px;
    &::after {
        position: absolute;
        left: 120px;
        right: 0;
        display: block;
        content: "";
        border-bottom: 1px solid #e4e7ed;
    }
    .title {
        box-sizing: border-box;
        display: inline-block;
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #409eff;
        font-size: 14px;
        border: 1px solid #e4e7ed;
        border-bottom: none;
        border-radius: 4px 4px 0 0;
        box-sizing: border-box;
        background: #ffffff;
    }
}
.publicMain {
    display: flex;
    justify-content: space-between;
    background-color: #eef1f5;
    padding: 10px;
    box-sizing: border-box;
    width: 100%;
    height: calc(100% - 50px);

    .member-title {
        height: 30px;
        line-height: 30px;
    }

    /deep/ ::-webkit-scrollbar {
        display: block;
    }

    .el-form-item {
        margin-bottom: 5px !important;
    }

    .party-icon {
        display: inline-block;
        width: 16px;
        height: 15px;
        background-image: url("../../assets/image112/icon_011.png");
    }

    // 左边树状列表卡片
    .card-l {
        //width: 320px;
        height: auto;
        overflow-y: auto;
        border: none;

        .cardtree {
            overflow-x: auto;
            width: 150%;

            .el-tree-node > .el-tree-node__children {
                overflow: auto;
                background-color: transparent;
            }

            /deep/ ::-webkit-scrollbar {
                display: block;
            }
        }
    }

    // 右边卡片
    .card-rb {
        width: calc(100% - 280px);
        height: 100%;
        overflow-y: auto;
        border: none;

        .card-4 {
            border: none;
            height: 100%;

            .demo-ruleForm {
                .ruleForm_box {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                    padding: 20px 0;

                    .ruleForm_item {
                        width: 48%;

                        .rulelable {
                            width: 100%;
                            height: 35px;
                        }

                        .ruleinput {
                            width: 100%;
                            display: flex;
                            justify-content: space-between;

                            .rulespan2 {
                                float: left;
                                width: 49%;

                                .rulespan2_input {
                                    width: 100%;
                                }
                            }
                        }
                    }

                    .ruleradio {
                        height: 75px;
                        line-height: 75px;
                    }
                }

                .ruleForm_bottom {
                    width: 100%;
                    text-align: right;
                    margin-top: 40px;
                }
            }
        }
    }

    .addressselect {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;

        .addressselect_item {
            width: 24%;
        }
    }

    .address_xx {
        width: 100%;
        height: 320px;
        display: flex;
        justify-content: space-between;

        .add_list {
            width: 24%;
            height: 300px;
            border: 1px solid #c0c6d9;
            border-radius: 5px;
            overflow-y: auto;
        }

        .add_map {
            width: 74%;
            height: 300px;
            border: 1px solid #c0c6d9;
        }
    }

    .custom-tree-node {
        position: relative;

        .el-icon-s-icon {
            content: url(../../assets/image112/icon_011.png);
            width: 15px;
            height: 15px;
            float: left;
            margin-top: 3px;
        }

        .tree-node-span {
            margin-left: 10px;
        }

        .el-icon-s-add {
            content: url(../../assets/image112/metro_05.png);
            width: 15px;
            margin-left: 10px;
        }

        .el-icon-s-add:hover {
            content: url(../../assets/image112/metro_03.png);
        }

        .el-icon-delete {
            content: url(../../assets/image112/metro_14.png);
            width: 15px;
            margin-left: 10px;
        }

        .el-icon-delete:hover {
            content: url(../../assets/image112/metro_13.png);
            // width: 12px;
            // height: 12px;
            // margin-left: 10px;
        }
    }

    .ZUZHIimg {
        position: relative;

        .threestyleimg {
            display: flex;
            flex-wrap: wrap;

            .threestyleimgtu {
                width: 100%;
                height: 70%;
                // background-color: red;
                display: flex;
                // justify-content: center;
                // align-items: center;
            }

            .threestyleimgbtnzzxz {
                input {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 463px;
                    height: 200px;
                    opacity: 0;
                    cursor: pointer;
                }
            }

            .el-icon-s-add {
                content: url(../../assets/image112/metro_05.png);
                width: 15px;
                margin-left: 10px;
            }

            .el-icon-s-add:hover {
                content: url(../../assets/image112/metro_03.png);
            }

            .el-icon-delete {
                content: url(../../assets/image112/metro_14.png);
                width: 15px;
                margin-left: 10px;
            }

            .el-icon-delete:hover {
                content: url(../../assets/image112/metro_13.png);
                // width: 12px;
                // height: 12px;
                // margin-left: 10px;
            }
        }

        .ZUZHIimg {
            position: relative;

            .threestyleimg {
                display: flex;
                flex-wrap: wrap;

                .threestyleimgtu {
                    width: 100%;
                    height: 70%;
                    // background-color: red;
                    display: flex;
                    // justify-content: center;
                    // align-items: center;
                }

                .threestyleimgbtnzzxz {
                    input {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 463px;
                        height: 200px;
                        opacity: 0;
                        cursor: pointer;
                    }
                }
            }
        }

        .el-form-item {
            margin-bottom: 0px;
        }
    }
}

.flex {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

/deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar-uploader .avatar {
    width: 148px;
    height: 148px;
    display: block;
}
</style>
